export default 'Sign up and get free plays';
